import { render } from "./Sidebar.vue?vue&type=template&id=8f25e628"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=8f25e628&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__